import React from 'react';
import { Box, Spinner, Text } from '@chakra-ui/react';
import { ITableResponse, ICatalogResponse, TABLE_MODE } from '../../../models/sessions';
import { AggregateTableView } from './table-modes/AggregateTableView';
import { DayTableView } from './table-modes/DayTableView';
import { WeekMatrixTableView } from './table-modes/WeekMatrixTableView';
import { PerSessionTableView } from './table-modes/PerSessionTableView';

interface CarichiTableProps {
  table: ITableResponse | undefined;
  catalog: ICatalogResponse | undefined;
  isLoading: boolean;
  isError: boolean;
}

/**
 * Router su modalità tabella. 4 view dedicate:
 *   - AGGREGATE: 1 riga atleta + footer Media/Somma/DevStd
 *   - DAY: solo presenti del giorno + counter X/Y
 *   - WEEK_MATRIX: 7 colonne giorno + Sum + Peak con cella picco evidenziata viola+★
 *   - PER_SESSION: 1 riga per (atleta×sessione), ordinato date desc, partita evidenziata
 */
export const CarichiTable: React.FC<CarichiTableProps> = ({
  table,
  catalog,
  isLoading,
  isError,
}) => {
  if (isLoading) {
    return (
      <Box p={8} textAlign="center">
        <Spinner />
        <Text mt={2} color="gray.500">Carico tabella…</Text>
      </Box>
    );
  }
  if (isError || !table || !catalog) {
    return (
      <Box p={8} textAlign="center" color="red.500">
        Errore caricamento dati. Verifica che il team sia selezionato.
      </Box>
    );
  }
  if (table.rows.length === 0) {
    return (
      <Box p={8} textAlign="center" color="gray.500">
        Nessuna sessione nel periodo selezionato per questo team.
      </Box>
    );
  }

  const mode = table.meta.mode;
  if (mode === TABLE_MODE.DAY) {
    return <DayTableView table={table} catalog={catalog} />;
  }
  if (mode === TABLE_MODE.WEEK_MATRIX) {
    return <WeekMatrixTableView table={table} catalog={catalog} />;
  }
  if (mode === TABLE_MODE.PER_SESSION) {
    return <PerSessionTableView table={table} catalog={catalog} />;
  }
  return <AggregateTableView table={table} catalog={catalog} />;
};
